module.exports = __webpack_public_path__ + "img/hands-praying.3bf0344f.svg";